import { compose, flatten, repeat, __ } from 'ramda'

export const VALIDATE_EMAIL_REGEXP = /^[a-zA-Z0-9!.#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/
export const VALIDATE_NAME = /^[\w\s-]+$/
export const LATIN_WITH_NUMBERS_SYMBOLS = /^[\w\s-./,;#№:*$!?()^%+{}|]+$/
export const LATIN_WITH_NUMBERS_ADDRESS_SYMBOLS = /^[\w\s-./,№:?()|]+$/
export const NOT_ALLOWED_ADDRESS_SYMBOLS = /[!#$%*=<>;{}+"^]/
export const LATIN_WITH_NUMBERS_SYMBOLS_EXTENDED = /^[\w\s-./,;#№:*$!?()^%+{}|"'\\@&]+$/
export const LATIN_LETTERS_WITH_SYMBOLS = /^[A-Za-z\s\-./,;#№:()]+$/
export const STATE_CHECK_REGEX = /^[A-Za-z\s\-./,№:()]+$/
export const LATIN_LETTERS_WITH_NUMBERS = /^[\w\s]+$/
export const MAX_LENGTH = 250
export const MAX_LENGTH_CITY = 100
export const MAX_IMAGE_SIZE = 10 * 1024 * 1024
export const MIN_IMAGE_SIZE = 32 * 1024
export const getIbanMask = () => {
  const maskPart = [/[a-z0-9]/, /[a-z0-9]/, /[a-z0-9]/, /[a-z0-9]/, ' ']
  return compose(
    flatten,
    repeat(__, 8)
  )(maskPart)
}
export const MAX_JOINT_ACC = 1
export const TARGET_PLATFORMS = {
  MKTD: 'MKTD',
  MT4: 'MT4',
  WT: 'WT',
  BP: 'BP',
  MT5: 'MT5',
  EXCH: 'EXCH',
  NUKK: 'NUKK',
  IMAIBO: 'IMAIBO'
}

export const EMPLOYMENT_ID = {
  EMPLOYED: 801,
  SELF_EMPLOYED: 802,
  UNEMPLOYED: 803,
  RETIRED: 804,
  STUDENT: 806
}

export const RTL_LANGUAGES = ['ar']

export const passwordExpressionByPlatformMT4 = {
  MT4: {
    digits: true,
    lowerCase: true,
    upperCase: true,
    specials: false,
    min: 6,
    max: 15,
    pattern: '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=\\S+$).{6,15}$',
    specialsAllowed: ''
  }
}

export const SOCKET_MESSAGES = {
  EMAIL_CONFIRMED: 'EMAIL_CONFIRMED'
}
